import { Controller } from "stimulus";
import $ from 'jquery';
import 'toastr/toastr.scss';
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import { OpenStreetMapProvider } from 'leaflet-geosearch';

const provider = new OpenStreetMapProvider();

export default class extends Controller {
    static targets = ["container"];
    static values = {
        icon: String
    };

    offices = [];
    selectedOfficeId = null;
    popup;
    marker;

    connect() {
        console.info('se conectó');
        this.createMap();
        this.map.setView([23.041667, -81.5775], 12); // CAMBIO 1: Matanzas en lugar de La Habana

        const activeOfficesUrl = this.data.get("active_offices_url");
        this.loadOffices(activeOfficesUrl);

        $(document).on('click', '.office', (event) => this.handleOfficeClick(event));
        // Event delegation for fullscreen images
        $(document).on('click', '.fullscreen-image', this.handleFullscreenImageClick.bind(this));
    }

    _isFullTime(value) {
        if (value === true || value === 1) return true;
        if (value === false || value === 0) return false;
        if (typeof value === 'string') {
            const lowerValue = value.toLowerCase().trim();
            return lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes' || lowerValue === 'on';
        }
        return Boolean(value);
    }
    
    highlightSelectedOffice() {
        // Remove active class from all office elements
        $('.office').removeClass('active');
        // Add active class to selected office if exists
        if (this.selectedOfficeId !== null) {
            $(`.office[data-id="${this.selectedOfficeId}"]`).addClass('active');
        }
    }
    
    handleFullscreenImageClick(event) {
        const img = event.target;
        const imageUrl = img.dataset.imageUrl;
        const officeName = img.dataset.officeName;
        
        if (imageUrl) {
            this.showFullscreenImage(imageUrl, officeName);
        }
    }

    createMap() {
        this.map = L.map(this.containerTarget, {
            attribution: false,
            attributionControl: false,
            dragging: false,
            interactive: false,
            scrollWheelZoom: false,
            zoomControl: false
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            zoom: 17,
            minZoom: 7,
            maxZoom: 19,
            zoomSnap: 0.25,
            touchZoom: false,
        }).addTo(this.map);
    }

    loadOffices(url) {
        // $.blockUI({ message: false });
        $.ajax({
            url: url,
            type: "GET",
            success: (res) => {
                // $.unblockUI();
                if (res && res.offices) {
                    this.renderOffices(res.offices);
                    this.showFirstOffice(); // CAMBIO 2: Mostrar la primera oficina
                }
            },
            error: (xhr, status, error) => {
                $.unblockUI();
                console.error("Error loading offices:", error);
            }
        });
    }

    // NUEVO MÉTODO: Muestra la primera oficina en el mapa
    showFirstOffice() {
        const firstValidOffice = this.offices.find(office =>
            office.latitude != 0.0 && office.longitude != 0.0
        );

        if (firstValidOffice) {
            const latLng = L.latLng(firstValidOffice.latitude, firstValidOffice.longitude);
            this.map.setView([firstValidOffice.latitude, firstValidOffice.longitude], 17);
            this.addMarker(
                latLng,
                firstValidOffice.name,
                firstValidOffice.phones,
                firstValidOffice.open_time,
                firstValidOffice.close_time,
                firstValidOffice.address,
                firstValidOffice.full_time,
                firstValidOffice.image_url,
                firstValidOffice.product_types
            );
            this.renderOfficeCard();
            this.selectedOfficeId = firstValidOffice.id;
            this.highlightSelectedOffice();
        }
    }

    renderOffices(offices) {
        $("#active_offices").empty();
        Object.entries(offices).forEach(([destinationName, dealers]) => {
            const destinationContainerId = `${destinationName.toLowerCase().replaceAll(' ', '-')}-dealers`;
            $("#active_offices").append(
                `<details open>
                      <summary><strong>${destinationName}</strong></summary>
                      <div id="${destinationContainerId}" class="pl-3"></div>
                  </details>`
            );

            Object.entries(dealers).forEach(([dealerName, offices]) => {
                const dealerContainerId = `${destinationContainerId}-${dealerName.toLowerCase().replaceAll(' ', '-')}-offices`;
                const color = dealerName.includes('REX') ? 'rgba(239, 64, 53, 1)' : '#0056a3';
                $(`#${destinationContainerId}`).append(
                    `<details open>
                          <summary style="color: ${color};"><strong>${dealerName}</strong></summary>
                          <div id="${dealerContainerId}" class="pl-3"></div>
                      </details>`
                );

                offices.forEach(office => {
                    this.offices.push(office);
                    $(`#${dealerContainerId}`).append(
                        `<div>
                             <strong class="text-dark office" role="button"
                                 data-id="${office.id}"
                                 data-latitude="${office.latitude}"
                                 data-longitude="${office.longitude}"
                                 data-name="${office.name}"
                                 data-phone="${office.phones}"
                                 data-optime="${office.open_time}"
                                 data-cltime="${office.close_time}"
                                 data-fulltime="${office.full_time}"
                                 data-address="${office.address}"
                                 data-image-url="${office.image_url || ''}"
                             >${office.name}</strong>
                         </div>`
                    );
                });
            });
        });
    }

    handleOfficeClick(event) {
        const latitude = event.target.dataset.latitude;
        const longitude = event.target.dataset.longitude;
        const id = event.target.dataset.id;
        const name = event.target.dataset.name;
        const phone = event.target.dataset.phone;
        const optime = event.target.dataset.optime;
        const cltime = event.target.dataset.cltime;
        const address = event.target.dataset.address;
        const fulltime = event.target.dataset.fulltime;
        const imageUrl = event.target.dataset.imageUrl;
        
        const latLng = L.latLng(latitude, longitude);
        const office = this.offices.find(office => String(office.id) === id);

        if (latitude == "0.0" && longitude == "0.0") {
            this.map.setView([23.041667, -81.5775], 12); // CAMBIO: Matanzas
            this.clearMarker();
        } else {
            this.addMarker(latLng, name, phone, optime, cltime, address, fulltime, imageUrl, office ? office.product_types : []);
            this.map.setView([latitude, longitude], 17);
        }

        // Señalar la oficina seleccionada en el árbol
        this.selectedOfficeId = office.id;
        this.highlightSelectedOffice();
        this.renderOfficeCard();
    }

    setPopupContent(name, phone, optime, cltime, address, fulltime, imageUrl = null, productTypes = []) {
        let imageHtml = '';
        if (imageUrl) {
            imageHtml = `<div class="text-center mb-2">
                            <img src="${imageUrl}" alt="${name}" class="img-fluid rounded fullscreen-image" 
                                 style="max-width: 200px; max-height: 150px; cursor: pointer;"
                                 data-image-url="${imageUrl}"
                                 data-office-name="${name.replace(/"/g, '&quot;').replace(/'/g, '&#39;')}">
                         </div>`;
        }
        
        const isFullTime = this._isFullTime(fulltime);
        const scheduleText = isFullTime ? '24 Horas' : (optime && cltime && optime !== '0' && cltime !== '0' ? `Apertura: ${optime} - Cierre: ${cltime}` : 'Horario no disponible');
        const productText = productTypes && productTypes.length > 0 ? productTypes.map(p => p.name).join(', ') : '';
        const content = imageHtml +
            `<h4 class="mb-2">${name}</h4>
              <b><span>Contacto: </span></b>${phone}<br>
              <b><span>Horario: </span></b>${scheduleText}<br>
              ${productText ? `<b><span>Productos: </span></b>${productText}<br>` : ''}
              <b><span>Dirección: </span></b>${address}<br>`;

        this.marker.bindPopup(content).openPopup();
    }

    addMarker(latLng, name, phone, optime, cltime, address, fulltime, imageUrl = null, productTypes = []) {
        this.clearMarker();

        const myIcon = L.icon({
            iconUrl: this.iconValue,
            className: 'pin-map',
            popupAnchor: [-3, -3],
            iconSize: [20, 30]
        });

        this.marker = L.marker(latLng, { icon: myIcon }).addTo(this.map);
        this.setPopupContent(name, phone, optime, cltime, address, fulltime, imageUrl, productTypes);
    }

    clearMarker() {
        if (this.marker) {
            this.marker.remove();
            this.marker = null;
        }
    }

    // La información de la oficina se muestra únicamente en el popup del mapa (setPopupContent).
    // Este método solo limpia la tarjeta inferior para evitar información duplicada.
    renderOfficeCard() {
        $(".mapcard").empty();
    }

    showFullscreenImage(imageUrl, officeName) {
        // Remove any existing fullscreen modal
        this.hideFullscreenImage();
        
        // Create modal backdrop
        const backdrop = document.createElement('div');
        backdrop.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.9);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            cursor: zoom-out;
        `;
        backdrop.onclick = this.hideFullscreenImage.bind(this);
        
        // Create image container
        const imgContainer = document.createElement('div');
        imgContainer.style.cssText = `
            max-width: 90vw;
            max-height: 90vh;
            overflow: auto;
        `;
        
        // Create the image
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = officeName || 'Office image';
        img.style.cssText = `
            max-width: 100%;
            max-height: 100%;
            display: block;
            box-shadow: 0 0 20px rgba(0,0,0,0.5);
        `;
        
        // Add close button
        const closeBtn = document.createElement('div');
        closeBtn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            background: rgba(255,255,255,0.8);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            z-index: 10000;
        `;
        closeBtn.innerHTML = '&times;';
        closeBtn.style.fontSize = '24px';
        closeBtn.style.color = '#333';
        closeBtn.onclick = function(e) {
            e.stopPropagation();
            this.hideFullscreenImage();
        }.bind(this);
        
        // Assemble
        imgContainer.appendChild(img);
        backdrop.appendChild(imgContainer);
        backdrop.appendChild(closeBtn);
        document.body.appendChild(backdrop);
        
        // Store reference to hide later
        this.fullscreenModal = backdrop;
    }

    hideFullscreenImage() {
        if (this.fullscreenModal) {
            this.fullscreenModal.remove();
            this.fullscreenModal = null;
        }
    }

    disconnect() {
        this.map.remove();
        // Also clean up fullscreen modal if open
        this.hideFullscreenImage();
    }
}